import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=8205d45a&scoped=true"
import script from "./cell.vue?vue&type=script&lang=js"
export * from "./cell.vue?vue&type=script&lang=js"
import style0 from "./cell.vue?vue&type=style&index=0&id=8205d45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8205d45a",
  null
  
)

export default component.exports